import { LinkButton, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DailyrentBanner.css';

const PROMO_CODE = 'VDOROGU26';

export interface IDailyrentBannerProps {
  url: string;
  onClick(): void;
}

export function DailyrentBanner(props: IDailyrentBannerProps) {
  return (
    <div className={styles['banner']} data-name="DailyrentBanner">
      <div className={styles['content']}>
        <div className={styles['header']}>
          <UIHeading1 color="text-inverted-default">Устройте себе бархатный отпуск</UIHeading1>
        </div>
        <LinkButton theme="inverted" size="M" href={props.url} onClick={props.onClick}>
          Отдохнуть осенью
        </LinkButton>
      </div>
      <div className={styles['decoration']}>
        <div className={styles['logo']} />
        <div className={styles['promo']}>
          <div className={styles['promo-field']}>
            <span className={styles['promo-code']} data-name="DailyrentBannerPromoCode">
              {PROMO_CODE}
            </span>
            <span className={styles['promo-icon']} />
          </div>
          <span className={styles['promo-caption']}>Промокод на 10%</span>
        </div>
      </div>
    </div>
  );
}
